// components/PaginatedSortableTable.js
import React from "react";

export default function PaginatedSortableTable({ data = [], renderRow }) {
  return (
    <tbody>
      {data.length === 0 ? (
        <tr>
          <td colSpan={12} className="text-center py-4">
            데이터가 없습니다.
          </td>
        </tr>
      ) : (
        data.map((item, index) => renderRow(item, index))
      )}
    </tbody>
  );
}
